// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet } from "react-native";
import { Picker } from "@react-native-picker/picker";
import colors from "../../../../../config/colors";
import ComboBoxStyle from "../../../../../styles/Farmer/ComboBoxStyle";

const ComboPicker = ({ items, onValueChange, plates, value, filters, field }) => {
    const [selectedValue, setSelectedValue] = useState(null);

    field = field ? field : 'name';

    useEffect(() => {
        setSelectedValue(value);
    }, [value]);

    const containerStyle = filters
        ? {
            borderColor: colors.green,
            width: "95%",
            fontSize: 12,
            backgroundColor: colors.white,
            borderRadius: 16,
            shadowColor: colors.white,
        }
        : {
            ...ComboBoxStyle.container,
            backgroundColor: colors.white,
            borderRadius: 16,
            shadowColor: colors.white,
            marginTop: 10,
            width: "75%",
        };
    return (
        <View style={containerStyle}>
            <View style={{ ...ComboBoxStyle.pickerContainer }}>
                {plates == true ? (
                    <Picker
                        selectedValue={selectedValue ?? undefined}
                        onValueChange={(itemValue, itemIndex) => {
                            setSelectedValue(itemValue);
                            onValueChange(itemValue);
                        }}
                        style={ComboBoxStyle.picker}
                        dropdownIconColor={colors.white}
                    >
                        {items?.map((item, index) => (
                            <Picker.Item
                                key={index}
                                label={item.registration}
                                value={item.id}
                                color={colors.white}
                            />
                        ))}
                    </Picker>
                ) : (
                    <Picker
                        selectedValue={selectedValue ?? undefined}
                        onValueChange={(itemValue, itemIndex) => {
                            setSelectedValue(itemValue);
                            onValueChange(itemValue);
                        }}
                        dropdownIconColor={colors.white}
                        style={ComboBoxStyle.picker}
                    >
                        {items?.map((item, index) => (
                            <Picker.Item
                                key={index}
                                label={item[field]}
                                value={item.id}
                                color={colors.white}
                            />
                        ))}
                    </Picker>
                )}
            </View>
        </View>
    );
};

export default ComboPicker;
